import { createReducer, on } from "@ngrx/store";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";
import { PaginaJornalOutputDto } from "src/app/domain/DTOs/output/jornal/pagina-jornal.output.dto";
import { obterPaginaJornalPorAutenticidade, obterPaginaJornalPorAutenticidadeSuccess, obterPaginaJornalPorAutenticidadeFailure, obterPaginaJornalPorAutenticidadeFinish, obterPaginaJornalPorAutenticidadeCatchError } from "../../actions/Autenticidade/obter-pagina-jornal-por-autenticidade.action";

export interface ObterPaginaJornalPorAutenticidadeState {
    response: EstruturaRetornoDadosOutputDto<PaginaJornalOutputDto> | null;
    error: string[] | null;
}

export const initialState: ObterPaginaJornalPorAutenticidadeState = {
    response: null,
    error: null,
};

export const ObterPaginaJornalPorAutenticidadeReducer = createReducer(
    initialState,
    on(obterPaginaJornalPorAutenticidade, state => ({ ...state, response: null, error: null })),
    on(obterPaginaJornalPorAutenticidadeSuccess, (state, { response }) => ({ ...state, response, error: null })),
    on(obterPaginaJornalPorAutenticidadeFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
    on(obterPaginaJornalPorAutenticidadeCatchError, (state, { response }) => ({ ...state, response: null, error: response.erros })),
    on(obterPaginaJornalPorAutenticidadeFinish, state => ({ ...state, response: null, error: null })),
);
